export default "__VITE_ASSET__B1Qml2dr__"